import $ from 'jquery';

$(function () {
  const fulfillUrl = $('.js-fulfill-earned-rewards-url').data('url');

  // This is used to keep track of the 'Fulfill All' ids when switching between pages
  let fulfilledIds = $('#fulfilled_ids');

  const getEarnedRewardIds = function () {
    const ids = [];
    $('.js-data-table-with-col-sort.activity-log-table')
      .DataTable()
      .data()
      .each(x => ids.push(x[4]));

    return ids;
  };

  const setFulfilledReward = function (earnedRewardId) {
    const fulfillRewardBtn = $(
      '.js-fulfill-earned-reward[data-earned-reward-id="' +
        earnedRewardId +
        '"]',
    );
    fulfillRewardBtn.prop('disabled', true);
  };

  const setError = function (earnedRewardId) {
    // if no earnedRewardId, it is assumed to be the fulfill all action
    if (earnedRewardId) {
      const fulfillRewardBtn = $(
        '.js-fulfill-earned-reward[data-earned-reward-id="' +
          earnedRewardId +
          '"]',
      );

      fulfillRewardBtn.text('Try Again');
      fulfillRewardBtn.parent().css('color', 'red');
      fulfillRewardBtn.parent().prepend('Error');
    } else {
      $('#js-fulfill-all-button').text('Try Again');
      $('#fulfill-all-error').css('display', 'inline');
    }
  };

  if ($('.activity-log table').length) {
    // Fulfill individual earned reward

    let earnedRewardId;
    $('.js-fulfill-earned-reward').on('click', function () {
      earnedRewardId = $(this).data('earned-reward-id');
      $('.js-fulfill-individual-earned-reward-modal').modal('show');
    });

    $('.js-fulfill-earned-reward-confirm-button').on('click', function () {
      $(this).addClass('ajax-loading');
      $.ajax({
        type: 'put',
        url: fulfillUrl,
        data: { id: earnedRewardId },
        success: function () {
          setFulfilledReward(earnedRewardId);
        },
        error: () => {
          setError(earnedRewardId);
        },
        complete: () => {
          $(this).removeClass('ajax-loading');
        },
      });
      $('.js-fulfill-individual-earned-reward-modal').modal('hide');
    });

    // Fulfill all earned rewards

    $('.js-fulfill-all-confirm-button').on('click', function () {
      $(this).addClass('ajax-loading');
      const earnedRewardIds = getEarnedRewardIds();
      fulfilledIds.val(earnedRewardIds);
      $.ajax({
        type: 'put',
        url: fulfillUrl,
        data: { id: earnedRewardIds, fulfill: true },
        success: function () {
          earnedRewardIds.map(function (earnedRewardId) {
            setFulfilledReward(earnedRewardId);
          });
        },
        error: () => {
          setError();
        },
        complete: () => {
          $(this).removeClass('ajax-loading');
        },
      });
      $('.js-fulfill-all-modal').modal('hide');
    });

    $('#js-fulfill-all-button').on('click', function () {
      $('.js-fulfill-all-modal').modal('show');
    });
  }

  $('.date-time .filter').on('click', function (event) {
    event.stopPropagation();
  });
});
